<template>
  <div class="login">
    <div class="main-nav-wrap">
      <b-container fluid>
        <b-row>
          <b-col>
            <b-navbar id="main-nav" class="px-0" toggleable="lg" type="light" variant="white" style="height:60px;">
              <b-navbar-brand to="/"><img src="/img/logo.png" alt="ARVID's logo" /></b-navbar-brand>
            </b-navbar>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <div class="content-wrap" role="main">
      <b-container fluid>
        <b-row>
          <b-col class="p-4 mx-auto" cols="12" md="6" lg="4">
            <b-overlay :show="loading" variant="dark" :opacity="0.15" spinner-variant="primary">
              <b-card>
                <h2>Log ind</h2>
                <b-alert variant="danger" :show="error !== null">{{error}}</b-alert>
                <b-form @submit.prevent="login()">
                  <b-form-group
                    id="username"
                    description=""
                    label="Brugernavn"
                    label-for="input-username"
                  >
                    <b-form-input id="input-username" v-model="username" autocomplete="username" trim required></b-form-input>
                  </b-form-group>
                  <b-form-group
                    id="password"
                    description=""
                    label="Adgangskode"
                    label-for="input-password"
                  >
                    <b-form-input id="input-password" type="password" autocomplete="current-password" v-model="password" trim required></b-form-input>
                  </b-form-group>
                  <b-button variant="primary" type="submit" class="float-right">Log ind</b-button>
                </b-form>
              </b-card>
            </b-overlay>
            <b-button class="mt-4" variant="outline-primary" to="/">Tilbage til forsiden</b-button>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    username: '',
    password: '',
    error: null,
    loading: false,
    page: null
  }),
  beforeRouteEnter (to, from, next) {
    const loggedIn = sessionStorage.getItem('user')
    if (loggedIn) {
      next('/')
    }
    next()
  },
  mounted() {
    if (this.$route.params.page) {
      this.page = this.$route.params.page
    }
  },
  methods: {
    login () {
      this.error = null
      this.loading = true
      this.axios.post('/api/token/', {username: this.username, password: this.password}).then((response) => {
        this.loading = false
        this.$store.dispatch("login", response.data)
      }).then(() => {
        if (this.page) {
          this.$router.push(this.page)
        } else {
          this.$router.push('/')
        }
      }).catch(error => {
        this.loading = false
        this.error = error
        console.error(error)
      })
    }
  }
}
</script>

<style>

</style>